import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import _ from 'lodash';
import React from 'react';
import { useState, useEffect } from 'react';
import { useGetCustomPoiByWorkspaceName } from '../components/ConfigurationDocumentLink/hooks';
import { ValueRender } from './AttributeCell';

export const PoiDropdownCell = (props: any) => {
    //todo fix
    const { data: localizedData } = useGetCustomPoiByWorkspaceName(props.dataItem?.sourceDirectory?.workspaceName);

    const [data, setData] = useState<any>(localizedData?.slice());

    const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data: any[] = localizedData!.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {
        setData(filterData(event.filter));
    };
    const handleChange = (e: DropDownListChangeEvent) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value,
            });
        }
    };

    const { dataItem } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    useEffect(() => {
        setData(localizedData?.slice());
    }, [props.dataItem?.sourceDirectory?.workspaceName, localizedData]);

    const clear = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        handleChange({
            target: {
                value: null,
            },
        } as any);
    };

    return (
        <DropDownList
            {...props}
            data={data}
            onChange={handleChange}
            value={localizedData?.find((c: any) => c?.purposeOfIssueId == dataValue?.purposeOfIssueId)}
            disabled={props.disabled || _.isEmpty(localizedData)}
            onFilterChange={filterChange}
            filterable={props?.filterable ?? true}
            dataItemKey="purposeOfIssueId"
            textField="purposeOfIssueName"
            valueRender={(element, value) => {
                return (
                    <ValueRender
                        element={element}
                        value={value}
                        textField={props.textField}
                        hasDeleteOption={props.hasDeleteOption}
                        clear={(e: any) => clear(e)}
                    />
                );
            }}
        />
    );
};
